import { useWindowScroll } from '@vueuse/core';

/**
 * Composable to track scroll direction based on window scroll position
 * @returns Object containing scroll direction and current scroll position
 */
export function useScrollDirection() {
	const { y: scrollY } = useWindowScroll();
	const previousScrollY = ref(0);
	const scrollDirection = ref<'up' | 'down'>('up');

	watch(scrollY, newScrollY => {
		if (newScrollY > previousScrollY.value) {
			scrollDirection.value = 'down';
		} else if (newScrollY < previousScrollY.value) {
			scrollDirection.value = 'up';
		}
		previousScrollY.value = newScrollY;
	});

	return {
		scrollY: readonly(scrollY),
		scrollDirection: readonly(scrollDirection),
		previousScrollY: readonly(previousScrollY)
	};
}
